export class GroupNotificationEvent {

    constructor(
        public eventId: number,
        public codeId: number,
        public name: string,
        public type: string
      ) {}
}
